import { Link } from "react-router-dom";
import styles from "../assets/sass/home.module.sass";

const thumbnailPath = process.env.PUBLIC_URL + '/thumbnails/';

export const scenesData = [
  {
    id: 1,
    link: "/ammocan",
    imgsrc: `${thumbnailPath}hp_ammocan.webp`,
    title: "Ammo Can",
  },
  {
    id: 2,
    link: "/centurion",
    imgsrc: `${thumbnailPath}hp_centurion.webp`,
    title: "Centurion",
  },
  {
    id: 3,
    link: "/classicplus",
    imgsrc: `${thumbnailPath}hp_classicplus.webp`,
    title: "Classic Plus",
  },
  {
    id: 4,
    link: "/classicselect",
    imgsrc: `${thumbnailPath}hp_classicselect.webp`,
    title: "Classic Select",
  },
  {
    id: 5,
    link: "/collector",
    imgsrc: `${thumbnailPath}hp_collector.webp`,
    title: "Collector",
  },
  {
    id: 6,
    link: "/colonial",
    imgsrc: `${thumbnailPath}hp_colonial.webp`,
    title: "Colonial",
  },
  {
    id: 7,
    link: "/fatboy",
    imgsrc: `${thumbnailPath}hp_fatboy.webp`,
    title: "Fatboy",
  },
  {
    id: 8,
    link: "/franklin",
    imgsrc: `${thumbnailPath}hp_franklin.webp`,
    title: "Franklin",
  },
  {
    id: 9,
    link: "/franklinn",
    imgsrc: `${thumbnailPath}hp_franklin.webp`,
    title: "Franklinn",
  },
  {
    id: 10,
    link: "/freedom",
    imgsrc: `${thumbnailPath}hp_freedom.webp`,
    title: "Freedom",
  },
  {
    id: 11,
    link: "/homesafes",
    imgsrc: `${thumbnailPath}hp_homesafe.webp`,
    title: "homesafes",
  },
  {
    id: 12,
    link: "/homesafese",
    imgsrc: `${thumbnailPath}hp_homese.webp`,
    title: "Homesafe Se",
  },
  {
    id: 13,
    link: "/lincoln",
    imgsrc: `${thumbnailPath}hp_lincoln.webp`,
    title: "Lincoln",
  },
  {
    id: 14,
    link: "/magnum",
    imgsrc: `${thumbnailPath}hp_magnum.webp`,
    title: "Magnum",
  },
  {
    id: 15,
    link: "/premium-homesafes",
    imgsrc: `${thumbnailPath}hp_premium_homesafe.webp`,
    title: "Premium HomeSafes",
  },
  {
    id: 16,
    link: "/presidential",
    imgsrc: `${thumbnailPath}hp_presedential.webp`,
    title: "Presidential",
  },
  {
    id: 17,
    link: "/tactical",
    imgsrc: `${thumbnailPath}hp_tactical.webp`,
    title: "Tactical 24",
  },
  {
    id: 18,
    link: "/usa",
    imgsrc: `${thumbnailPath}hp_usa.webp`,
    title: "USA",
  },
  {
    id: 19,
    link: "/vaultdoor",
    imgsrc: `${thumbnailPath}hp_vaultdoor.webp`,
    title: "Vault Door",
  },
  // {
  //   id: 17,
  //   link: "/inspector",
  //   imgsrc: `${thumbnailPath}hp_vaultdoor.webp`,
  //   title: "Model Inspector",
  // },
];

export default function Home() {

  return (
    <>
      <header className={styles.header}>
        <div className={styles.logo}>
          <img src="logo.png" alt="" />
        </div>
        <div className={styles.page_title_wrapper}>
          <h1 className={styles.page_title}>
            Configure your LibertySafe product.
          </h1>
          <p className={styles.page_subtitle}>
            Click on the product and start your configuration.
          </p>
        </div>
      </header>
      <main>
        <div className={styles.gallary}>
          <div className={styles.row}>
            {scenesData &&
              scenesData.map((scenes) => {
                return (
                  <Link
                    key={scenes.id}
                    to={scenes.link}
                    className={styles.thumbnail}
                  >
                    <div>
                      <img
                        className={styles.thumbnail_img}
                        src={scenes.imgsrc}
                        alt={scenes.title}
                      />
                    </div>
                    <div className={styles.name}>{scenes.title}</div>
                  </Link>
                );
              })}
          </div>
        </div>
      </main>
    </>
  );
}
